var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-table-body-item",class:[{'sele':_vm.selectInner, 'border-left': _vm.borderLeft, 'border-right': _vm.borderRight, 'borderY': _vm.borderY}],on:{"click":_vm.ClickRow}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37da6fcf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-table/src/ui-table-body-item.vue
// module id = 684
// module chunks = 0